/* import __COLOCATED_TEMPLATE__ from './copilot.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import safeWindowOpen from 'embercom/lib/safe-window-open';

interface Args {}

// this is a temporary URL. it'll be updated once we have deployed the unmanaged package
const SALESFORCE_GENERIC_INSTALL_URL =
  'https://login.salesforce.com/packaging/installPackage.apexp?p0=04tgL0000005TB3';

export default class SalesforceCopilot extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: any;
  @service declare intercomEventService: $TSFixMe;

  @tracked openSection?: string;

  get salesforceConfiguration() {
    return this.finStandaloneService.salesforceConfig;
  }

  get copilotSeatCount() {
    return this.appService.app.humanAdminsWithCopilotSeat.length;
  }

  @action setSection(section: string) {
    this.openSection = section;
  }

  @action openInstallLink() {
    safeWindowOpen(this.installUrl);
  }

  get installUrl() {
    if (this.salesforceConfiguration?.instanceUrl) {
      let url = new URL(SALESFORCE_GENERIC_INSTALL_URL);

      return `${this.salesforceConfiguration.instanceUrl}${url.pathname}${url.search}`;
    }

    return SALESFORCE_GENERIC_INSTALL_URL;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Copilot': typeof SalesforceCopilot;
  }
}
